import { useMutation, useQueryClient } from 'react-query';

import Api from '../../api/api';

export const reinstateUser = async (userId: string) => {
  const [response, bodyOrError] = await Api.patch(`users/${userId}/reinstate-user`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useReinstateUser = () => {
  const queryClient = useQueryClient();

  return useMutation('reinstateUser', reinstateUser, {
    onSuccess: () => {
      queryClient.invalidateQueries('getUsersByPage');
      queryClient.invalidateQueries('getUsersCount');
      queryClient.invalidateQueries(['getReportedUserById']);
      queryClient.invalidateQueries('reportedUsers');
    },
  });
};
